export function misc() {
    $jq3('.extended-search__activate').on('click', function (e) {
        e.preventDefault();
        $jq3('.extended-search').addClass("extended-search--is-active");
    });

    $jq3('.extended-search__deactivate').on('click', function (e) {
        e.preventDefault();
        $jq3('.extended-search').removeClass("extended-search--is-active");
    });

    $jq3('[data-fancybox="gallery"]').fancybox({
        infobar: false,
        toolbar: true,
        buttons: [
            "close"
        ],
        btnTpl: {
            close:
                '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
                "</button>",

            // Arrows
            arrowLeft:
                '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                "</button>",

            arrowRight:
                '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                "</button>",
        },

    });

    $jq3('.jumplink').on('click', function (e) {
        e.preventDefault();

        const target = $jq3(this).data("jumplink-target");

        if (target === undefined)
            return;

        if ($jq3('#' + target).length) {
            const headerHeight = $jq3(".header").outerHeight();
            const topOffset = $jq3('#' + target).offset().top - headerHeight;

            $jq3('html, body').animate({ scrollTop: topOffset }, 500);
        }
    });


    $jq3('.js-jumplink').on('click', function (e) {
        const target = $jq3(this).attr('href');

        if (target === undefined)
            return;

        if ($jq3(target).length) {
            e.preventDefault();

            //const headerHeight = $jq3(".header").outerHeight();
            const topOffset = $jq3(target).offset().top;

            $jq3('html, body').animate({ scrollTop: topOffset }, 500);
        }
    })

    //Lazyloading background images
    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');
        if(bg){
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });

    inView('#ogulu-waypoint')
        .on('enter', function() {
            if(parseInt($jq3("#ogulu-waypoint")[0].getAttribute("data-initialized")) === 0) {
                $jq3("#ogulu-waypoint")[0].setAttribute("data-initialized", "1");

                $jq3("#ogulu-waypoint")[0].innerHTML = oguluContent;
            }
        });
}